import type { SentryModule } from '../types';

export const MODULE_OWNERSHIP: Record<SentryModule, string> = {
  auth: 'team-obd',
  login: 'team-obd',
  signup: 'team-obd',
  // Old product picker: /merchantwebapp/landing
  landing: 'team-obd',
  // New PG Home (aka landingV2): /pg/summary/overview
  home: 'team-smb',
  onboarding: 'team-obd',
  payment_links: 'team-pga',
  payment_forms: 'team-pga',
  payment_buttons: 'team-pga',
  payments: 'team-smb',
  orders: 'team-smb',
  refunds: 'team-smb',
  disputes: 'team-smb',
  settlements: 'team-smb',
  payouts: 'team-payout',
  developers: 'team-obd',
  reports: 'team-smb',
  settings: 'team-obd',
  offers: 'team-smb',
  one_click_checkout: 'team-smb',
  easy_split: 'team-smb',
  softpos: 'team-fp',
  customers: 'team-smb',
  customisation: 'team-smb',
  subscriptions: 'team-fp',
  risk_shield: 'team-fp',
  vba: 'team-smb',
  vswebapp: 'team-fp',
  cross_border: 'team-fp',
  flowwise: 'team-pga',
  relay: 'team-fp',
  bbps: 'team-pgwan',
  international_payment_gateway: 'team-fp',
  global_collection: 'team-fp',
  // Legacy Summary container (pre-v2 overview)
  summary: 'team-smb',
  insights: 'team-smb',
  suspicious: 'team-fp',
  apps: 'team-pga',
  downtimes: 'team-pga',
  embedded_components: 'team-pga',
};
